module.exports = __webpack_public_path__ + "static/media/amex.23cd5a21.svg";